<template>
  <div class="market-analysis">
    <div class="header-ctn">
      <div class="title-ctn">
        <span class="title">营销分析-小智会员</span>
        <img src="~@/assets/questionTip.png" @click="showTooltip" />
      </div>
    </div>
    <div class="desc">活动时间内，小智会员服务号发布营销活动的效果统计</div>
    <div class="search-ctn">
      <div class="field-group">
        <van-field v-model="startTime" label="发布开始时间" input-align="right" readonly placeholder="请选择开始时间" @click="showStartTimePicker" />
        <van-field v-model="endTime" label="发布结束时间" input-align="right" readonly placeholder="请选择结束时间" @click="showEndTimePicker" />
        <van-field rows="1" autosize type="textarea" v-model="promotionName" label="活动名称" input-align="right" readonly placeholder="请选择活动名称" @click="showPromotionPicker" />
      </div>
      <div class="btn" @click="doSearch">查询</div>
    </div>
    <div class="rect-chart">
      <div class="rect-list">
        <div class="trapezoid t1">
          <div class="row-text">
            <div class="action">触达</div>
            <div class="action-num">{{ resultData.reachPer }}</div>
            <div class="action-unit">/人</div>
          </div>
        </div>
        <div class="trapezoid t2">
          <div class="row-text">
            <div class="action">点击</div>
            <div class="action-num">{{ resultData.clickPer }}</div>
            <div class="action-unit">/人</div>
          </div>
        </div>
        <div class="trapezoid t3">
          <div class="row-text">
            <div class="action">下单</div>
            <div class="action-num">{{ resultData.orderPer }}</div>
            <div class="action-unit">/人</div>
          </div>
        </div>
      </div>
      <div class="img-container">
        <img src="~@/assets/robot_arrow_1.png" />
        <img src="~@/assets/robot_arrow_2.png" />
      </div>
      <div class="num-container">
        <div class="num-li">
          <div class="num">
            <span>{{ resultData.clickConRate }}</span>
            <span class="percent">%</span>
          </div>
          <div class="txt">点击转化率</div>
        </div>
        <div class="num-li">
          <div class="num">
            <span>{{ resultData.orderConRate }}</span>
            <span class="percent">%</span>
          </div>
          <div class="txt">下单转化率</div>
        </div>
      </div>
    </div>
    <div class="swiper-container card-panel-list">
      <div class="swiper-wrapper">
        <div class="swiper-slide card-panel">
          <div class="content">
            <div class="title">触达人数</div>
            <div class="raw-data">
              <span class="raw-data-txt">环比</span>
              <span :class="resultData.qoqRpClass" class="raw-data-num">{{ resultData.qoqRpValue }}</span>
              <img v-if="resultData.qoqRpSrc" :src="resultData.qoqRpSrc" />
            </div>
          </div>
        </div>
        <div class="swiper-slide card-panel">
          <div class="content">
            <div class="title">点击人数</div>
            <div class="raw-data">
              <span class="raw-data-txt">环比</span>
              <span :class="resultData.qoqCpClass" class="raw-data-num">{{ resultData.qoqCpValue }}</span>
              <img v-if="resultData.qoqCpSrc" :src="resultData.qoqCpSrc" />
            </div>
          </div>
        </div>
        <div class="swiper-slide card-panel">
          <div class="content">
            <div class="title">下单人数</div>
            <div class="raw-data">
              <span class="raw-data-txt">环比</span>
              <span :class="resultData.qoqOpClass" class="raw-data-num">{{ resultData.qoqOpValue }}</span>
              <img v-if="resultData.qoqOpSrc" :src="resultData.qoqOpSrc" />
            </div>
          </div>
        </div>
        <div class="swiper-slide card-panel">
          <div class="content">
            <div class="title">下单金额</div>
            <div class="raw-data">
              <span class="raw-data-txt">环比</span>
              <span :class="resultData.qoqOpaClass" class="raw-data-num">{{ resultData.qoqOpaValue }}</span>
              <img v-if="resultData.qoqOpaSrc" :src="resultData.qoqOpaSrc" />
            </div>
          </div>
        </div>
        <div class="swiper-slide card-panel">
          <div class="content">
            <div class="title">点击转化率</div>
            <div class="raw-data">
              <span class="raw-data-txt">环比</span>
              <span :class="resultData.qoqCcrClass" class="raw-data-num">{{ resultData.qoqCcrValue }}</span>
              <img v-if="resultData.qoqCcrSrc" :src="resultData.qoqCcrSrc" />
            </div>
          </div>
        </div>
        <div class="swiper-slide card-panel">
          <div class="content">
            <div class="title">下单转化率</div>
            <div class="raw-data">
              <span class="raw-data-txt">环比</span>
              <span :class="resultData.qoqOcrClass" class="raw-data-num">{{ resultData.qoqOcrValue }}</span>
              <img v-if="resultData.qoqOcrSrc" :src="resultData.qoqOcrSrc" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="market-chart">
      <van-loading v-if="loading" type="spinner" />
      <template v-if="lineChartData.data">
        <line-chart ref="chart" :chart-data="lineChartData" :line-type="'mutiple'" />
      </template>
      <template v-else>
        <div class="empty-ctn">
          <div class="empty-img">
            <img src="~@/assets/empty.png" />
          </div>
          <div class="no-text">暂无数据</div>
        </div>
      </template>
    </div>
    <van-popup v-model="showSTPicker" round position="bottom">
      <van-datetime-picker v-model="startDate" type="date" title="发布开始时间" :min-date="minDate" :max-date="maxDate" @confirm="onConfirmStartTime" @cancel="onCancelStartTime" />
    </van-popup>
    <van-popup v-model="showETPicker" round position="bottom">
      <van-datetime-picker v-model="endDate" type="date" title="发布结束日期" :min-date="minEndDate" :max-date="maxDate" @confirm="onConfirmEndTime" @cancel="onCancelEndTime" />
    </van-popup>
    <van-popup v-model="showPromotPicker" round position="bottom">
      <van-picker title="活动名称" show-toolbar :columns="promotionList" @confirm="onConfirmPromotion" @cancel="onCancelPromotion" />
    </van-popup>
    <van-popup v-model="showTip" round position="bottom" :style="{ height: '50%' }">
      <div class="tip-container">
        <p class="tip">
          <span>触达人数：</span>统计时间内，看到活动推送的人数
        </p>
        <p class="tip">
          <span>点击人数：</span>统计时间内，点击活动推送的人数
        </p>
        <p class="tip">
          <span>下单人数：</span>统计时间内，下单的顾客数
        </p>
        <p class="tip">
          <span>下单金额：</span>统计时间内，下单的金额
        </p>
        <p class="tip">
          <span>点击转化率：</span>统计时间内，看到活动的顾客中，点击活动的顾客占比
        </p>
        <p class="tip">
          <span>下单转化率：</span>统计时间内，点击活动的顾客中，下单的顾客占比
        </p>
        <p class="tip">
          <span>环比：</span>指连续2个统计周期内的量的变化比，如当期为2020/5/1—2020/5/31，则上期数为2020/4/1—2020/4/30
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { parseTime, getDateAfter } from '@/utils/index.js'

import { getPromotionList, getMemberMarketDataStat } from '@/api/robot'
import LineChart from './LineChart'
import { toast } from '@/utils/index'

import Swiper from 'swiper' //导入
import 'swiper/swiper-bundle.min.css'
const downSrc = require('@/assets/robot_down.png')
const upSrc = require('@/assets/robot_up.png')
export default {
  components: {
    LineChart
  },
  data() {
    const startDate = getDateAfter(-30)
    const endDate = getDateAfter(-1)
    const startTime = parseTime(startDate, '{y}-{m}-{d}')
    const endTime = parseTime(endDate, '{y}-{m}-{d}')
    return {
      loading: false,
      startTime,
      endTime,
      promotionName: '',
      promotionId: '',
      minDate: new Date(2016, 0, 1),
      minEndDate: new Date(2016, 0, 1),
      maxDate: getDateAfter(-1),
      startDate,
      endDate,
      showSTPicker: false,
      showETPicker: false,
      showPromotPicker: false,
      promotionList: [],
      showTip: false,
      resultData: {
        reachPer: 0,
        orderPer: 0,
        clickPer: 0,
        clickConRate: 0,
        orderConRate: 0,
        qoqRpValue: 0,
        qoqCpValue: 0,
        qoqOpValue: 0,
        qoqOpaValue: 0,
        qoqCcrValue: 0,
        qoqOcrValue: 0,
        curDate: '',
        preDate: ''
      },
      lineChartData: {
        type: 'market',
        cardType: 4,
        data: null
      }
    }
  },
  computed: {},
  created() {
    this.getPromotionList(true)
  },
  mounted() {
    new Swiper('.card-panel-list', {
      loop: false,
      freeMode: true,
      width: 120,
      on: {
        transitionEnd: function(swiper, event) {
          if (this.getTranslate() <= -440) {
            this.setTranslate(-440)
          }
        }
      }
    })
  },
  methods: {
    resizeChart() {
      if (this.$refs.chart && this.$refs.chart.chart) {
        this.$refs.chart.chart.resize()
      }
    },
    resetPromotionInfo() {
      this.promotionId = ''
      this.promotionName = ''
      this.promotionList = []
    },
    async getPromotionList(init = false) {
      try {
        let promotionList = []
        const result = await getPromotionList({
          startTime: this.startTime,
          endTime: this.endTime
        })
        promotionList = result || []
        promotionList.forEach(item => {
          item.text = item.promotionName
          item.id = item.promotionId
        })
        this.promotionList = promotionList
        if (this.promotionList.length > 0) {
          this.promotionName = this.promotionList[0].promotionName
          this.promotionId = this.promotionList[0].promotionId
        } else {
          this.promotionList = [{ text: '暂无活动', id: -1, disabled: true }]
        }
        if (init && this.promotionId) {
          // 第一次进入加载数据
          this.getMemberMarketDataStat()
        }
      } catch (error) {
        console.log('getPromotionList', error)
      }
    },
    transClass(i) {
      let className = ''
      if (i === 0) {
        className = ''
      } else if (i > 0) {
        className = 'up'
      } else if (i < 0) {
        className = 'down'
      }
      return className
    },
    transSrc(i) {
      let src = ''
      if (i === 0) {
        src = ''
      } else if (i > 0) {
        src = upSrc
      } else if (i < 0) {
        src = downSrc
      }
      return src
    },
    transData(i) {
      return i !== 0 ? i : '持平'
    },
    validateField() {
      if (this.startTime === '') {
        toast('请选择开始时间')
        return false
      }
      if (this.endTime === '') {
        toast('请选择结束时间')
        return false
      }
      if (this.startDate > this.endDate) {
        toast('开始时间不能大于结束时间')
        return false
      }
      const date = new Date(this.startDate)
      date.setDate(date.getDate() + 30 * 6)
      if (this.endDate.getTime() > date.getTime()) {
        toast('日期最长跨度为180天')
        return false
      }
      if (!this.promotionName) {
        toast('请选择活动名称')
        return false
      }
      return true
    },
    doSearch() {
      this.getMemberMarketDataStat()
    },
    async getMemberMarketDataStat() {
      try {
        if (!this.validateField()) return
        this.loading = true
        const res = await getMemberMarketDataStat({
          promotionId: this.promotionId,
          startTime: this.startTime,
          endTime: this.endTime
        })
        let resultData = res
        // 转化需要个格式
        resultData.qoqRpClass = this.transClass(resultData.qoqRp)
        resultData.qoqRpSrc = this.transSrc(resultData.qoqRp)
        resultData.qoqRpValue = this.transData(resultData.qoqRp)
        resultData.qoqCpClass = this.transClass(resultData.qoqCp)
        resultData.qoqCpSrc = this.transSrc(resultData.qoqCp)
        resultData.qoqCpValue = this.transData(resultData.qoqCp)
        resultData.qoqOpClass = this.transClass(resultData.qoqOp)
        resultData.qoqOpSrc = this.transSrc(resultData.qoqOp)
        resultData.qoqOpValue = this.transData(resultData.qoqOp)
        resultData.qoqOpaClass = this.transClass(resultData.qoqOpa)
        resultData.qoqOpaSrc = this.transSrc(resultData.qoqOpa)
        if (resultData.qoqOpa !== 0) {
          if (resultData.qoqOpa >= 1000000 || resultData.qoqOpa <= -1000000) {
            resultData.qoqOpaValue = '¥' + resultData.qoqOpaStr
          } else {
            resultData.qoqOpaValue = '¥' + resultData.qoqOpa
          }
        } else {
          resultData.qoqOpaValue = '持平'
        }
        resultData.qoqCcrClass = this.transClass(resultData.qoqCcr)
        resultData.qoqCcrSrc = this.transSrc(resultData.qoqCcr)
        resultData.qoqCcrValue = resultData.qoqCcr !== 0 ? resultData.qoqCcr + '%' : '持平'
        resultData.qoqOcrClass = this.transClass(resultData.qoqOcr)
        resultData.qoqOcrSrc = this.transSrc(resultData.qoqOcr)
        resultData.qoqOcrValue = resultData.qoqOcr !== 0 ? resultData.qoqOcr + '%' : '持平'
        this.resultData = resultData
        const { curDate, preDate, orderAmountTrend } = this.resultData
        this.lineChartData = {
          ...this.lineChartData,
          curDate,
          preDate,
          data: orderAmountTrend
        }
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log('getMemberMarketDataStat', e)
      }
    },
    showTooltip() {
      this.showTip = true
    },
    showStartTimePicker() {
      this.showSTPicker = true
    },
    showEndTimePicker() {
      this.showETPicker = true
    },
    showPromotionPicker() {
      this.showPromotPicker = true
    },
    onConfirmStartTime(v) {
      const time = parseTime(this.startDate, '{y}-{m}-{d}')
      this.showSTPicker = false
      if (time !== this.startTime) {
        this.minEndDate = this.startDate //设置结束日期最小值
        this.startTime = time
        this.endTime = ''
        this.endDate = null
      }
    },
    onCancelStartTime(v) {
      this.showSTPicker = false
    },
    onConfirmEndTime(v) {
      const time = parseTime(this.endDate, '{y}-{m}-{d}')
      this.showETPicker = false
      if (time !== this.endTime) {
        this.endTime = time
        this.resetPromotionInfo() //清空活动名称
        this.getPromotionList()
      }
    },
    onCancelEndTime(v) {
      this.showETPicker = false
    },
    onConfirmPromotion(value) {
      this.showPromotPicker = false
      if (value.disabled) return
      this.promotionName = value.promotionName || ''
      this.promotionId = value.promotionId || ''
    },
    onCancelPromotion() {
      this.showPromotPicker = false
    }
  }
}
</script>

<style lang="less" scoped>
.market-analysis {
  min-height: 548px;
  background: #ffffff;
  box-shadow: 0 0 12px 0 rgba(48, 48, 60, 0.08);
  border-radius: 4px;
  padding: 20px 14px 10px 14px;
  .header-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title-ctn {
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #333333;
    }
    .header-right {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #999999;
    }
    img {
      width: 15px;
      height: 15px;
      padding-left: 6px;
      padding-right: 6px;
    }
  }
  .desc {
    font-family: PingFangSC-Regular;
    font-size: 11px;
    color: #999999;
    margin: 16px 0;
  }
  .search-ctn {
    //height: 180px;
    padding: 0 14px;
    border: 1px solid #f3f3f3;
    border-radius: 6px;
    .btn {
      width: 130px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #4978f2;
      margin: 10px auto;
      border-radius: 18px;
      font-size: 16px;
      color: #ffffff;
    }
  }
  .field-group {
    position: relative;
    &::before {
      position: absolute;
      box-sizing: border-box;
      width: 100%;
      content: ' ';
      pointer-events: none;
      top: -2px;
      left: 0;
      border-bottom: 1px solid #ebedf0;
      transform: scaleY(0.5);
    }
    .van-cell {
      padding: 8px 0;
    }
    .van-cell:not(:last-child):after {
      display: none;
    }
    .van-cell:last-child:after {
      display: none;
    }
    /deep/ .van-field__label {
      font-size: 14px;
      color: #999999;
    }
    /deep/ .van-field__control {
      padding-right: 20px;
    }
    /deep/ .van-field__body {
      position: relative;
      &::after {
        top: 5px;
        right: 2px;
        content: '';
        position: absolute;
        width: 8px;
        height: 8px;
        border-top: 2px solid #408afd;
        border-right: 2px solid #408afd;
        transform: rotate(135deg);
      }
    }
  }
  .rect-chart {
    display: flex;
    margin: 20px 0;
    .rect-list {
      display: flex;
      flex-direction: column;
      .trapezoid {
        height: 0;
        border-right: 20px solid transparent;
        position: relative;
        &.t1 {
          width: 180px;
          border-top: 44px solid #eaf0ff;
        }
        &.t2 {
          width: 157px;
          border-top: 44px solid #bcd0ff;
        }
        &.t3 {
          width: 133px;
          border-top: 44px solid #749cfe;
        }
        &:nth-of-type(2) {
          margin: 10px 0;
        }
      }
      .row-text {
        position: absolute;
        left: 0;
        top: -44px;
        width: 180px;
        height: 44px;
        font-family: PingFangSC-Regular;
        display: flex;
        align-items: center;
        .action {
          font-size: 14px;
          color: #333333;
          padding: 0 6px 0 18px;
        }
        .action-num {
          font-family: DINAlternate-Bold;
          font-size: 20px;
          color: #333333;
        }
        .action-unit {
          font-size: 14px;
          color: #151515;
        }
      }
    }
    .img-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img:nth-child(1) {
        width: 25px;
        height: 45px;
        margin-top: 9px;
      }
      img:nth-child(2) {
        width: 45px;
        height: 45px;
        margin-left: -19px;
        margin-top: 22px;
      }
    }
    .num-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Regular;
      margin-left: 18px;
      width: 60px;
      .num-li:nth-child(1) {
        margin-bottom: 5px;
        margin-top: 5px;
      }
      .num-li:nth-child(2) {
        margin-top: 20px;
      }
      .num {
        font-family: DINAlternate-Bold;
        font-size: 22px;
        color: #333333;
      }
      .percent {
        font-family: DINAlternate-Bold;
        font-size: 14px;
        color: #151515;
      }
      .txt {
        font-size: 12px;
        color: #a3a4a8;
      }
    }
  }
  .swiper-container {
    width: 100%;
  }
  .card-panel-list {
    .card-panel {
      width: 112px;
      height: 60px;
      box-sizing: border-box;
      border-radius: 3px;
      padding: 8px 0 8px 6px;
      margin-right: 6px;
      background: #f7f8f9;
      .title {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #666666;
        margin-bottom: 6px;
      }
      .raw-data {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 12px;
        height: 18px;
        .raw-data-txt {
          color: #a3a5a8;
        }
        img {
          width: 7px;
          height: 9px;
          margin-left: 2px;
        }
        .raw-data-num {
          font-family: PingFangSC-Semibold;
          font-size: 12px;
          color: #666666;
          margin-left: 4px;
          &.up {
            color: #fe6010;
          }
          &.down {
            color: #76b813;
          }
        }
      }
    }
  }
  .market-chart {
    margin-top: 20px;
  }
}
</style>
